// @flow
import { DEFAULT_LANGUAGE } from 'Store/internationalization/constants';

import enDownload from './en/sabrina.png';

const availableConfig = {
  en: enDownload,
};

export const getImageByVariant = (variant: string) => {
  // eslint-disable-line
  const image = availableConfig[variant] || availableConfig[DEFAULT_LANGUAGE];
  return image;
};
